import { render, staticRenderFns } from "./School.vue?vue&type=template&id=014ba64e"
import script from "./School.vue?vue&type=script&lang=js"
export * from "./School.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports